var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRose = function SvgRose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillOpacity: 0,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M11.266 20v-5.333m4.936 3.786a3.7 3.7 0 0 1-1.856.93.664.664 0 0 1-.84-.84c.127-.695.45-1.338.93-1.855a3.7 3.7 0 0 1 1.855-.931.663.663 0 0 1 .842.842 3.7 3.7 0 0 1-.931 1.854M7.734 5.872c.853 1.901 2.971 2.964 5.666 2.395V10.4a3.21 3.21 0 0 1-3.2 3.2H8.445"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10.251 8.143a1.606 1.606 0 0 1 1.548-2.01v0a1.605 1.605 0 0 1 1.6 1.6v.534"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M15.533 10.4a4.267 4.267 0 0 1-8.534 0V8.267a4.267 4.267 0 1 1 8.534 0z"
  })));
};
export default SvgRose;